import React from "react";

export default function Card({ title, children }) {
  return (
    <div className="bg-white border border-[#EAEAEA] rounded-xl p-6 shadow-luxury-light">
      <h3 className="font-spectral text-xl tracking-tight mb-3">{title}</h3>
      <div className="gold-hairline mb-4" />
      {children}
    </div>
  );
}
